var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 33,
    viewBox: "0 0 39 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64619 7.81654C4.42936 2.47733 10.2163 -0.593064 16.1979 0.0958692C21.7238 0.732329 26.3587 4.45554 28.2126 9.61736L28.9453 9.61737C32.9911 9.61472 37.0347 11.753 38.3724 15.9755C39.6551 20.0239 38.1656 24.4366 34.6917 26.8795C33.907 27.4312 32.8236 27.2424 32.2719 26.4578C31.7201 25.6731 31.9089 24.5897 32.6936 24.038C34.9279 22.4668 35.886 19.6286 35.061 17.0246C34.2912 14.5951 31.8799 13.0888 28.948 13.091L26.931 13.091C26.138 13.091 25.4458 12.554 25.2487 11.7859C24.1098 7.34766 20.3524 4.07102 15.8004 3.54673C11.2484 3.02245 6.8445 5.35904 4.72649 9.42221C2.60848 13.4854 3.21496 18.4338 6.25152 21.8652C6.8872 22.5836 6.82019 23.6812 6.10184 24.3169C5.38349 24.9526 4.28583 24.8856 3.65014 24.1672C-0.340032 19.6582 -1.13698 13.1557 1.64619 7.81654ZM18.1199 12.9029C18.7982 12.2247 19.8979 12.2247 20.5762 12.9029L26.1028 18.4295C26.7811 19.1077 26.7811 20.2074 26.1028 20.8857C25.4245 21.564 24.3248 21.564 23.6466 20.8857L21.0861 18.3253L21.0921 31.2623C21.0925 32.2216 20.3153 32.9996 19.3561 33C18.3968 33.0004 17.6189 32.2232 17.6184 31.264L17.6124 18.3229L15.0496 20.8857C14.3713 21.564 13.2716 21.564 12.5933 20.8857C11.915 20.2074 11.915 19.1077 12.5933 18.4295L18.1199 12.9029Z",
    fill: "black",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.824bbb6f0949c6d64e04a27a68709b12.svg";
export { ForwardRef as ReactComponent };